<template>
    <div
        class="alert-wrapper"
        :class="css"
    >
        <p v-html="html"></p>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    data: function(){
        return {
            css: '',
            html: ''
        };
    },
    computed: {
        ...mapGetters('fundation', [
            'isOnline',
            'needUpdate',
            'getVerbose'
        ]),
    },
    watch: {
        isOnline:{
            handler (val) {
                if(val === false){
                    this.html = this.getVerbose('topBarAlert_offline');
                    this.css = 'not-connected';
                }
                else {
                    this.html = '';
                    this.css = '';
                }
            },
            immediate: true,
        },
        needUpdate:{
            handler (val) {
                if(val === true){
                    this.html = this.getVerbose('topBarAlert_update');
                    this.css = 'need-update';
                }
                else {
                    this.html = '';
                    this.css = '';
                }
            },
            immediate: true,
        }
    },
};
</script>

<style lang="scss">
    .alert-wrapper {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 999;

        margin-bottom: 0;
        line-height: 22px;
        min-height: 64px;

        text-align: center;
        font-weight: 600;
        color: white;
        overflow: hidden;
        display: flex;
        align-items: center;
        vertical-align: middle;
        @media (min-width: 500px) {
            min-height: 32px;
        }

        p {
            padding: 5px;
            width: 100%;
            overflow-wrap: break-word;
            display: none;
        }

        &.not-connected {
            background-color: #EE3224;
            transform: translate(0,0);
            p {
                display: block;
            }
        }
        &.need-update {
            background-color: #409EFF;
            transform: translate(0,0);
            cursor: pointer;
            p {
                display: block;
            }
        }
    }


</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/layouts/dashboard/TopbarAlert.vue